import React from 'react'
import { CookiesProvider } from 'react-cookie'
import Loadable from 'react-loadable'
import { connect } from 'react-redux'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import Loader from './components/LayoutComponents/Loader'
import PrivateLayout from './layouts/private'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader fullScreen={false} />,
  })

const routes = [
  // Dashboards
  {
    path: '/',
    component: loadable(() => import('./pages/InitializePage/index')),
    exact: true,
  },
  {
    path: '/callback',
    component: loadable(() => import('./pages/Callback')),
    exact: true,
  },
  {
    path: '/main',
    component: loadable(() => import('./pages/MainPage/index')),
    exact: true,
  },
  {
    path: '/info',
    component: loadable(() => import('./pages/InfoPage/index')),
    exact: true,
  },
  {
    path: '/create-account',
    component: loadable(() => import('./pages/CreateAccount/index')),
    exact: true,
  },
  {
    path: '/campainpreview',
    component: loadable(() => import('./pages/CampainPreview')),
    exact: true,
  },
]

type RoutesModuleProps = RouteComponentProps<{}> & {
  dispatch: any
}

class RoutesModule extends React.Component<RoutesModuleProps, {}> {
  render() {
    return (
      <Switch>
        <CookiesProvider>
          <PrivateLayout>
            {/* <Route path="/oidc-callback" component={CallbackPage} /> */}
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                exact={route.exact}
              />
            ))}
          </PrivateLayout>
        </CookiesProvider>
      </Switch>
    )
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    dispatch,
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(RoutesModule)
